import { render, staticRenderFns } from "./PositionForm.vue?vue&type=template&id=8c76c780"
import script from "./PositionForm.vue?vue&type=script&lang=js"
export * from "./PositionForm.vue?vue&type=script&lang=js"
import style0 from "./PositionForm.vue?vue&type=style&index=0&id=8c76c780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports